import { render, staticRenderFns } from "./ConstructionFile.vue?vue&type=template&id=0ddd7d03&scoped=true"
import script from "./ConstructionFile.vue?vue&type=script&lang=js"
export * from "./ConstructionFile.vue?vue&type=script&lang=js"
import style0 from "./ConstructionFile.vue?vue&type=style&index=0&id=0ddd7d03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd7d03",
  null
  
)

export default component.exports